var App = App || {};

(function ($) {
	var $body,
		OCE;

	// *** READY ***
	$(document).ready(function () {
		// Staticizzo variabili $ (in modo da evitare continue intrusioni nel dom)
		$body = $('body');
		commonFnHandler();
		App.triggerEvent('main::appReady')

		$('.frm_forms ').removeClass('with_frm_style');
	});

	// Translate field error
	$(document).ready(function() {
		const currentLang = document.documentElement.lang ?? 'en-US';
		const messageNotValid = 'The sum is invalid';
		const messageNotBlank = 'This field cannot be blank';

		const $fieldErrorElements = $('.frm_error');
		const $bannerErrorElement = $('.frm_error_style');
		const $successMessage = $('.frm_message');

		const fieldInvalidStrings =  {
			'it-IT': 'La somma non è valida',
			'fr-FR': "La somme n'est pas valide",
			'es-ES': 'La suma no es valida',
			'de-DE': 'Die Summe ist nicht gültig',
			'zh-hant': '總和無效',
			'ja': '合計が無効です',
			'ru-RU': 'сумма недействительна',
			'ko-KR': '합계가 유효하지 않습니다',
			'en-cn': 'The sum is invalid',
			'fr-cn': "La somme n'est pas valide",
		};

		const fieldErrorStrings = {
			'it-IT': 'Questo campo non può essere vuoto',
			'fr-FR': 'Ce champ ne peut pas être vide.',
			'es-ES': 'Este campo no puede estar en blanco',
			'de-DE': 'Dieses Feld darf nicht leer sein.',
			'zh-hant': '此字段不得留空。',
			'ja': 'このフィールドを空白にすることはできません。',
			'ru-RU': 'Данное поле не может быть незаполненным.',
			'ko-KR': '이 필드는 비워둘 수 없습니다.',
			'en-cn': 'This field cannot be blank.',
			'fr-cn': 'Ce champ ne peut être laissé en blanc.',
		};

		const bannerErrorString = {
			'it-IT': 'Controllare il valore inserito nei campi evidenziati.',
			'fr-FR': 'Veuillez vérifier la valeur que vous avez saisie dans les champs en surbrillance.',
			'es-ES': 'Compruebe el valor introducido en los campos destacados.',
			'de-DE': 'Bitte überprüfen Sie die in den hervorgehobenen Feldern eingegebenen Werte.',
			'zh-hant': '请检查突出显示字段的输入值。',
			'ja': 'ハイライトされているフィールドの入力値をご確認ください。',
			'ru-RU': 'Пожалуйста, проверьте значение, которое Вы ввели в выделенные поля.',
			'ko-KR': '강조 표시된 입력란에 입력한 값을 확인해 주십시오.',
			'en-cn': 'Errors are marked in red. Please go back to the top and make the appropriate changes',
			'fr-cn': 'Les erreurs sont indiquées en rouge. Veuillez revenir en haut de la page et effectuer les changements appropriés.',
		};

		const successMessageString = {
			'it-IT': 'Il sondaggio è stato inviato con successo.<br />Le Sue risposte ci aiuteranno a fornire a Lei e ai Suoi clienti la migliore assistenza possibile.<br />Grazie per aver dedicato tempo al completamento del sondaggio.<br />Automobili Lamborghini',
			'fr-FR': 'L’enquête a été soumise avec succès.<br /> Vos réponses nous aideront à vous fournir, ainsi qu’à vos clients, la meilleure assistance possible.<br /> Nous vous remercions d’avoir pris le temps de répondre à cette enquête.<br /> Automobili Lamborghini',
			'es-ES': 'La encuesta se ha enviado con éxito.<br />Sus respuestas nos ayudarán a facilitarle a usted y a sus clientes la mejor asistencia posible.<br />Gracias por dedicar su tiempo a completar esta encuesta.<br />Automobili Lamborghini',
			'de-DE': 'Die Umfrage wurde erfolgreich übermittelt.<br /> Ihre Antworten helfen uns dabei, Sie und Ihre Kunden bestmöglich zu unterstützen.<br /> Vielen Dank für Ihre Teilnahme an dieser Umfrage.<br /> Automobili Lamborghini',
			'zh-hant': '您的答案已成功提交。非常感谢！<br /> Automobili Lamborghini',
			'ja': 'アンケートが正常に送信されました。<br />皆様の回答を参考にすることで、ディーラーの皆様とお客様に最高のサポートを提供することができるようになります。<br />アンケートへのご協力誠にありがとうございました。<br />Automobili Lamborghini',
			'ru-RU': 'Опрос был успешно отправлен.<br />Ваши ответы помогут нам предоставить Вам и Вашим клиентам наилучшую поддержку.<br />Благодарим Вас за то, что уделили время заполнению этого опроса.<br />Automobili Lamborghini',
			'ko-KR': '설문조사가 성공적으로 완료되었습니다.<br />보내주신 응답을 통해 당사에서 더욱 원활하게 파트너님과 고객에게 가능한 최고의 지원을 제공할 수 있습니다.<br />시간을 내어 설문조사를 완료해 주셔서 감사합니다.<br />Automobili Lamborghini',
			'en-cn': 'The survey was submitted successfully.<br />Your answers will help us to provide you and your clients with the best possible support.<br />Thank you for your time in completing this survey.<br />Automobili Lamborghini',
			'fr-cn': 'Le sondage a été envoyé avec succès.<br />Vos réponses nous aideront à vous fournir, ainsi qu’à vos clients, la meilleure assistance possible.<br />Nous vous remercions d’avoir consacré du temps à remplir ce sondage.<br />Automobili Lamborghini',
		};

		const translateStrings = () => {
			let translate = true;

			console.log("translate", $($fieldErrorElements));

			$fieldErrorElements?.each((index) => {
				if(($($fieldErrorElements[index])?.text() === messageNotValid)) {
					$($fieldErrorElements[index])?.text(fieldInvalidStrings[currentLang]);
				} else if(($($fieldErrorElements[index])?.text() === messageNotBlank)) {
					$($fieldErrorElements[index])?.text(fieldErrorStrings[currentLang]);
				}
			});

			if (currentLang !== 'en-US') {
				// $fieldErrorElements.text(fieldErrorStrings[currentLang]);
				$bannerErrorElement.text(bannerErrorString[currentLang]);
				$successMessage.html(successMessageString[currentLang]);
			}
		}

		const makeObserver = () => {
			const observer = new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					if (mutation.addedNodes.length) {
						const $fieldErrorElements = $('.frm_error');

						if ($fieldErrorElements.length > 0) {
							observer.disconnect();

							let translate = true;

							console.log("translate", $($fieldErrorElements));

							$fieldErrorElements?.each((index) => {
								if(($($fieldErrorElements[index])?.text() === messageNotValid)) {
									$($fieldErrorElements[index])?.text(fieldInvalidStrings[currentLang]);
								} else if(($($fieldErrorElements[index])?.text() === messageNotBlank)) {
									$($fieldErrorElements[index])?.text(fieldErrorStrings[currentLang]);
								}
							});

							if (currentLang !== 'en-US') {
								// $fieldErrorElements.text(fieldErrorStrings[currentLang]);
								$bannerErrorElement.text(bannerErrorString[currentLang]);
								$successMessage.html(successMessageString[currentLang]);
							}
						}
					}
				});
			});

			observer.observe(document.body, { childList: true, subtree: true });
		}

		translateStrings();

		$(document).on('click', '.frm_button_submit', function(event) {
			makeObserver();
		});

		$(document).on('change', 'select', function() {
			makeObserver();
		});

	});


	const commonFnHandler = () => {
		setBrowserClass();
		initSmartListener();
		setVHFix();

		OCE = gajus.orientationchangeend({});
		// Attach event listener to the "orientationchangeend" event.
		OCE.on('orientationchangeend', () => {
			setVHFix();
		});
	}

	const setBrowserClass = () => {
		const ua = window.navigator.userAgent;
		if (ua.indexOf('Trident/') > 0 || ua.indexOf('MSIE ') > 0) {
			$('html').addClass('ie');
		}
		if (ua.indexOf('Edge/') > 0) {
			$('html').addClass('edge');
		}
	}

	const initSmartListener = () => {
		const smartScroll = App.throttle(function () { App.triggerEvent("main::smartScroll"); }, 200);
		const smartResize = App.debounce(function () { App.triggerEvent("main::smartResize"); }, 250);
		$(window).on('scroll', smartScroll);
		$(window).on('resize', smartResize);
	}

	const setVHFix = () => {
		var vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', vh + 'px');
	}

	// hide intro-text in last page
	const $formMessage = $('.frm_message');
	const $introText = $('.intro-text');

	if($formMessage.length > 0) {
		$formMessage.addClass('text-center');
		$introText.addClass('d-none');
	}

	// Calculate sum of an array
	$( ".js_calcSum" ).each(function() {
		let inputs = $(this).find("input[type='number']");
		let total = $(this).find("input[type='text']");

		inputs.on("keyup change", function(e) {
			// Get array of all values
			let inputsValue = inputs.map(function(){return $(this).val();}).get();
			// Get array of numbers
			inputsValue = inputsValue.map(Number);
			// Calculate the sum
			let sum = 0;
			for (let i = 0; i < inputsValue.length; i++) {
					sum += inputsValue[i];
			}

			total.val(sum + '%');
			let totalValue = total.val();
			//console.log(totalValue);
			if(totalValue == '100%' || totalValue == '0%') {
				total.css("color", "inherit");
			} else {
				total.css("color", "red");
			}

		});

	});

	// Calculate average of an array
	$( ".js_calcAverage" ).each(function() {
		let inputs = $(this).find("input[type='number']");
		let total = $(this).find("input[type='text']");

		inputs.on("keyup change", function(e) {
			// Get array of all values
			let inputsValue = inputs.map(function(){return $(this).val();}).get();
			// Get array of numbers
			inputsValue = inputsValue.map(Number);
			// Calculate the sum
			let sum = 0;
			for (let i = 0; i < inputsValue.length; i++) {
					sum += inputsValue[i];
			}
			// Calculate the average
			let average = sum / inputsValue.length;
			// Formatting total with two decimals
			const totalFormatted = new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
		 	}).format(average);

			//total.val(average + '%');
			total.val(totalFormatted + '%');
			let totalValue = total.val();

		});

	});


	// Calculate average of an array
	$( ".js_calcAverage-txt" ).each(function() {
		let inputs = $(this).find("input[type='number']");
		let total = $(this).find("input[type='text']");

		inputs.on("keyup change", function(e) {
			// Get array of all values
			let inputsValue = inputs.map(function(){return $(this).val();}).get();
			// Get array of numbers
			inputsValue = inputsValue.map(Number);
			// Calculate the sum
			let sum = 0;
			for (let i = 0; i < inputsValue.length; i++) {
					sum += inputsValue[i];
			}
			// Calculate the average
			let average = sum / inputsValue.length;
			// Formatting total with two decimals
			const totalFormatted = new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 0,
				maximumFractionDigits: 1,
		 	}).format(average);

			total.val(totalFormatted);

		});

	});

	// average on columns
	// e.g. use average-string for field and average-string-result for result
	$('[class*="average-"][class*="-result"]').each(function () {
    const match = $(this).attr('class').match(/average-([a-zA-Z]+)-result/);

		if (match) {
			const className = match[1];

			const inputs = $(`.average-${className}`).find('input[type="number"]');
			const total = $(this).find('input[type="text"]');

			inputs.on("keyup change", function(e) {
				// Get array of all values
				let inputsValue = inputs.map(function(){return $(this).val();}).get();
				// Get array of numbers
				inputsValue = inputsValue.map(Number);
				// Calculate the sum
				let sum = 0;
				for (let i = 0; i < inputsValue.length; i++) {
						sum += inputsValue[i];
				}
				// Calculate the average
				let average = sum / inputsValue.length;
				// Formatting total with two decimals
				const totalFormatted = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
					}).format(average);

				//total.val(average + '%');
				total.val(totalFormatted + '%');
				let totalValue = total.val();

			});
    }
	});

	// total on columns
	// e.g. use average-string for field and average-string-result for result
	$('[class*="total-"][class*="-result"]').each(function () {
    const match = $(this).attr('class').match(/total-([a-zA-Z0-9]+)-result/);

		if (match) {
			const className = match[1];

			const inputs = $(`.total-${className}`).find('input[type="number"]');
			const total = $(this).find('input[type="text"]');

			inputs.on("keyup change", function(e) {
				// Get array of all values
				let inputsValue = inputs.map(function(){return $(this).val();}).get();
				// Get array of numbers
				inputsValue = inputsValue.map(Number);
				// Calculate the sum
				let sum = 0;
				for (let i = 0; i < inputsValue.length; i++) {
						sum += inputsValue[i];
				}

				total.val(sum + '%');
				let totalValue = total.val();
				//console.log(totalValue);
				if(totalValue == '100%' || totalValue == '0%') {
					total.css("color", "inherit");
				} else {
					total.css("color", "red");
				}

			});
    }
	});



	// Prevent Enter Key Submitting Forms
	$('form input').keydown(function (e) {
    if (e.keyCode == 13) {
        var inputs = $(this).parents("form").eq(0).find(":input");
        if (inputs[inputs.index(this) + 1] != null) {
            inputs[inputs.index(this) + 1].focus();
        }
        e.preventDefault();
        return false;
    }
});

})(jQuery);
